import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as apiLogin, register as apiRegister } from '../services/api';
import { showAlert } from '../components/service/AlertService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem('user');
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (error) {
      console.error('Error parsing user from localStorage:', error);
      // If there's an error parsing, clear localStorage
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      return null;
    }
  });
  const navigate = useNavigate();

  const login = async (credentials) => {
    try {
      const { data, error } = await apiLogin(credentials);
      if (data && data.token) {
        const userData = {
          username: credentials.username,
          token: data.token
        };
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
        navigate('/activity');
        return { success: true };
      }
      return { success: false, error: error.code || 'ERROR_LOGIN' };
    } catch (error) {
      console.error('Login error:', error);
      return { 
        success: false, 
        error: error.message || 'An error occurred during login' 
      };
    }
  };

  const register = async (userData) => {
    try {
      const { data, error } = await apiRegister(userData);
      if (data) {
        showAlert(data);
        return { success: true };
      }
      return { success: false, error: error.code || 'ERROR_REGISTER' };
    } catch (error) {
      console.error('Register error:', error);
      return { 
        success: false, 
        error: error.message || 'An error occurred during registration' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    navigate('/');
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
